import React from "react";
import ErrorView from "../ErrorView/ErrorView";
import LoadingView from "../LoadingView/LoadingView";

function ViewWrapper({ loading, error, children }) {
  return !loading ? !error ? <>{children}</> : <ErrorView /> : <LoadingView />;
}

export default ViewWrapper;
